export default __webpack_public_path__ + "static/cuff-a500474d108404953d70f2f9480bfda4.jpg";